/** «Делистинг 27.10 · через 6 дн.», «… · через 5 ч», «… · сегодня». UTC, as the
 *  venue announces it. */
export function delistingText(deliveryIso: string, now: Date): string {
  const at = new Date(deliveryIso);
  const day = String(at.getUTCDate()).padStart(2, "0");
  const month = String(at.getUTCMonth() + 1).padStart(2, "0");
  const hours = Math.floor((at.getTime() - now.getTime()) / 3_600_000);
  const left =
    hours >= 48 ? `через ${String(Math.floor(hours / 24))} дн.`
    : hours >= 1 ? `через ${String(hours)} ч`
    : hours >= 0 ? "меньше часа"
    : "прошёл";
  return `Делистинг ${day}.${month} · ${left}`;
}
